export const LOAD_STATE = {
    IDLE: 'idle',
    LOADING: 'loading',
    LOADED: 'loaded',
    FAILED: 'failed',
} as const;

export type LoadState = typeof LOAD_STATE[keyof typeof LOAD_STATE];
